import React, { Component } from 'react';
import { MdRemoveRedEye } from '@react-icons/all-files/md/MdRemoveRedEye';
import { MdArrowForward } from '@react-icons/all-files/md/MdArrowForward';
import NodeRSA from "node-rsa";
import CommonAction from "../../services/common";
import Validator from "../../actions/validation";
import filter from "lodash/filter";
import { error } from "../Toast";
import { FaBan } from '@react-icons/all-files/fa/FaBan';
import AuthAction from "../../services/auth";
import mailer from "../../actions/mail";
import SlackWebHook from "../../actions/slack";
import BgAgent from '../custom/svg/bgAgent';
import { withRouter } from 'next/router'
import ComponentConfig from '../../config/component.json';

class AgentRegister extends Component {

    constructor(props) {
        super(props);
        this.state = {
            firstName: "",
            lastName: "",
            gender: "male",
            email: "",
            mobile: "",
            countryId: "",
            password: "",
            cPassword: "",
            courseIds: "",
            countryList: [],
            courseList: [],
            hasError: false,
            loading: false,
            submitted: false,
            countryCodebyIpData: null
        }
    }

    componentDidMount() {
        CommonAction.listCountry().then((res) => {
            let response = res.data.listCountry;
            if(response.code === "200" && response.status === "success") {
                if(this.props.countryCodeByIp){
                    var cntryId = filter(response.data.countries, ['code',this.props.countryCodeByIp])[0].countryId;
                }
                this.setState({
                    ...this.state,
                    countryList: response.data.countries,
                    countryCodebyIpData: cntryId,
                    countryId: cntryId
                })
            }else {
                console.log(res);
            }
        }).catch((err) => {
          SlackWebHook.sendSlackMessage('AgentRegister','componentDidMount',`${err.message}`)
        });
    }

    /**
     * @purpose: set all the fields value to state
     * @author: Arijit Deb Roy
     * @params: e: <event>
     * @return: void
     */
    onChange = (e) => {
        e.persist();
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value,
            submitted: false
        })
    };

    /**
     * @purpose: register user after validation
     * @author: Arijit Deb Roy
     * @params: e: <event>
     * @return: void
     */
    onSubmit = (e) => {
        e.preventDefault();
        this.setState({
            ...this.state,
            cPassword: this.state.password,
            password: this.hashRSA(),
            submitted: true,
            loading: true
        }, () => {
            this.validator().then((res) => {
                if(res){
                    let input = {
                        firstName: this.state.firstName.trim(),
                        lastName: this.state.lastName.trim(),
                        gender: this.state.gender,
                        email: this.state.email.trim(),
                        mobile: this.state.mobile.trim(),
                        countryId: Number(this.state.countryId),
                        password: this.state.password,
                        roleMachineName: "agent",
                        status: "active"
                    };

                    AuthAction.registerPartner(input).then((res) => {
                        let response = res.data.registerPartner;
                        if(response.code === "201" && response.status === "Success") {
                            const data = {
                                "emailTitle": `Welcome to ${process.env.NEXT_PUBLIC_BRAND_NAME}`,
                                "name": `${input.firstName} ${input.lastName}`,
                                "actionUrl":`${process.env.NEXT_PUBLIC_APP_URI}`
                            }
                            mailer.sendMail(input.email, 'afterSignUp-mail', [], [], `Welcome to ${process.env.NEXT_PUBLIC_BRAND_NAME}`, false, data)
                            this.props.router.push('/?as=agent');
                        }else {
                            this.setState({
                                ...this.state,
                                password: "",
                                loading: false
                            })
                            error(response.message);
                        }
                    }).catch((err) => {
                      SlackWebHook.sendSlackMessage('AgentRegister','onSubmit',`${err.message}`)
                    });
                }else{
                    this.setState({
                        ...this.state,
                        password: "",
                        loading: false
                    })
                    error("Missing required fields");
                }
            });
        })
    }

    /**
     * @purpose: handle validation
     * @author: Arijit Deb Roy
     * @params: void
     * @return: [[promise]]
     */
    validator = () => {
        return new Promise((resolve, reject) => {
            try{
                if(Validator.text(this.state.firstName.trim())
                    && Validator.text(this.state.lastName.trim())
                    && Validator.mobile(this.state.mobile.trim())
                    && Validator.email(this.state.email.trim())
                    && Validator.passwordStrength(this.state.cPassword.trim(), "week")
                    && Validator.positiveNumber(this.state.countryId)){
                    resolve(true);
                }else {
                    resolve(false);
                }
            }catch(err){
                reject(err)
            }
        })
    }

    /**
     * @purpose: encrypt password before sending through network
     * @author: Arijit Deb Roy
     * @params: void
     * @return: <string>
     */
    hashRSA = () => {
        let pubKey = new NodeRSA(process.env.NEXT_PUBLIC_RSA_PUB_KEY);
        return pubKey.encrypt(this.state.password, 'base64');
    }

    /**
   * @purpose: toggle the password field to show and hide password
   * @author: Susanta Chakraborty
   * @param: void
   * @return: void
   */
    passwordToggle = () => {
        const input = document.getElementById('agent-password');
        const unmaskBtn = document.getElementById('unmask')
        if(input.type === 'password') {
        input.type = 'text';
        unmaskBtn.classList.add('active');
        } else {
        input.type = 'password';
        unmaskBtn.classList.remove('active');
        }
    }

    render() {
        const { password, cPassword, firstName, lastName, mobile, gender, email, countryId, countryList, loading, submitted, countryCodebyIpData } = this.state;

        return (
            <div className="register-wrapper d-flex justify-content-start align-items-start">
                <div className="img-left--wrapper">
                    <BgAgent className='desktop-only'/>
                    <BgAgent className='mobile-only'/>

                </div>
                <section className="register-default--wrapper">
                    <div className="register-as-text txt-32--title">
                        Register as a {process.env.NEXT_PUBLIC_BRAND_NAME} Agent
                    </div>
                    <h5 className="txt-16--body">Create a free {process.env.NEXT_PUBLIC_BRAND_NAME} account to add students, teachers and get a cashback when they sign up.</h5>
                    {
                        ComponentConfig?.AGENT ?
                        <form className="form-register--wrapper">
                            <div className="form-group mb-3">
                                <label className="col-form-label">Personal</label>
                                <div className="d-sm-flex justify-content-start align-items-center">
                                    <input
                                        type="text"
                                        className={`form-control ${(submitted && (Validator.text(firstName.trim()) ? '' : 'error')).toString()}`}
                                        onChange={this.onChange}
                                        placeholder="First Name"
                                        value={firstName}
                                        name="firstName"
                                        autoComplete="given-name"
                                    />

                                    <input
                                        type="text"
                                        className={`form-control ${(submitted && (Validator.text(lastName.trim()) ? '' : 'error')).toString()}`}
                                        onChange={this.onChange}
                                        placeholder="Last Name"
                                        value={lastName}
                                        name="lastName"
                                        autoComplete="family-name"
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label className="col-form-label">Gender</label>
                                    <div className="flex-row align-items-center">
                                        <label className="radio-wrapper me-2">
                                            <input type="radio" name="gender" value="male" id="inlineRadio1" checked={gender === "male"} onChange={this.onChange} />
                                            <span className={`checkmark radio `} />
                                            <span htmlFor="inlineRadio1">Male</span>
                                        </label>
                                        <label className="radio-wrapper me-2">
                                            <input type="radio" name="gender" value="female" id="inlineRadio2" checked={gender === "female"} onChange={this.onChange}/>
                                            <span className={`checkmark radio `} />
                                            <span htmlFor="inlineRadio2">Female</span>
                                        </label>
                                        <label className="radio-wrapper">
                                            <input type="radio" name="gender" value="other" id="inlineRadio3" checked={gender === "other"} onChange={this.onChange}/>
                                            <span className={`checkmark radio `} />
                                            <span htmlFor="inlineRadio2">Other</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group mb-3">
                                <label className="col-form-label">Credentials</label>
                                <div className="d-sm-flex justify-content-start align-items-center">
                                    <input
                                        type="email"
                                        className={`form-control ${(submitted && (Validator.email(email.trim()) ? '' : 'error')).toString()}`}
                                        onChange={this.onChange}
                                        placeholder="Email"
                                        value={email}
                                        name="email"
                                        autoComplete="email"
                                    />
                                    <div className="absolute-wrapper">
                                        <input type="password"
                                            onChange={this.onChange}
                                            className={`form-control ${(submitted && (Validator.passwordStrength(cPassword.trim(), "week") ? '' : 'error')).toString()}`}
                                            placeholder="Password"
                                            value={password}
                                            name="password"
                                            id="agent-password"
                                            autoComplete="new-password"
                                        />
                                        <div id="unmask" onClick={this.passwordToggle}
                                            className="unmask"
                                        ><MdRemoveRedEye fontSize="24px" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group mb-3">
                                <label className="col-form-label">Contact</label>
                                <div className="d-sm-flex justify-content-start align-items-center">
                                    <select
                                        onChange={this.onChange}
                                        className={`form-select custom-select-lg ${(submitted && (Validator.positiveNumber(countryId) ? '' : 'error')).toString()}`}
                                        name="countryId"
                                        value={countryId}
                                    >
                                        <option>Select Country</option>
                                        {countryCodebyIpData != null && countryList.length > 0 && countryList.map((country, index) =>
                                        <option value={country.countryId}
                                            defaultValue={country.countryId == countryCodebyIpData ? true: false }
                                            key={index}>
                                            {country.name}
                                        </option>)}
                                    </select>
                                    <div className="absolute-wrapper">
                                        <input type="text"
                                            onChange={this.onChange}
                                            className={`form-control phone-no ${(submitted && (Validator.mobile(mobile.trim()) ? '' : 'error')).toString()}`}
                                            placeholder="Phone Number"
                                            name="mobile"
                                            value={mobile}
                                            autoComplete="tel-national"
                                        />
                                        <p className="c-code txt-16--body lh-20"> {filter(countryList, ['countryId', parseInt(countryId)]).length > 0 ? filter(countryList, ['countryId', parseInt(countryId)])[0].dialCode : '+91'}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="btn-wrapper">
                                <button className="btn-solid-large --primary w-100" onClick={this.onSubmit} disabled={loading || submitted}>
                                    Get Started
                                    <div className={`icon-btn--layer ${loading || submitted ? 'no-border' : 'primary-border'}`}>
                                        {loading ? <div className={`lds-ring`}><div /><div /><div /><div /></div> : <MdArrowForward fontSize="24px" />}
                                    </div>
                                </button>
                            </div>
                        </form>
                        :
                        <form className="form-register--wrapper">
                            <div className="text-center p-5 mb-1">
                                <FaBan fontSize="150px" color="red"/>
                            </div>
                            <h6>Agent registration is not available. Please contact the site admin.</h6>
                        </form>
                    }
                    <div className="link-2-login">
                        <a href="/" className="txt-14--caption color-black">Have an account? Sign In</a>
                    </div>
                </section>
            </div>
        )
    }
}
export default withRouter(AgentRegister);
